/**
 * Home page JS
 *
 * The vehicle-request form and newsletter form both submit natively via
 * Shopify's built-in {% form %} tags — no custom JS needed. Success and
 * error states are rendered server-side after page reload.
 *
 * If the request or newsletter form is submitted, the URL fragment auto-
 * scrolls to that section (Shopify appends #RequestForm or #NewsletterForm
 * to the URL after post).
 *
 * This file is kept for any future home-page interactivity.
 */
(function () {
  if (window.__blueminum_home_ran) return;
  window.__blueminum_home_ran = true;

  // Placeholder for future home-page JS (studio dot animations, etc.)
})();